interface JwtPayload {
  exp?: number;
}

export function isJwtTokenValid(token: string, now = Date.now()): boolean {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const payload = JSON.parse(atob(padded)) as JwtPayload;

    return typeof payload.exp === 'number' && now < payload.exp * 1000;
  } catch {
    return false;
  }
}
